import { camelCaseKeys } from '@/utils/changeCase';
import { StackAndMachineConfiguration } from '../components/StartBuildDialog/types';

const transformStacksAndMachineTypes = (originalStacksAndMachines: any) => {
  const availableMachineTypeConfigs = Object.fromEntries(
    Object.entries(originalStacksAndMachines.available_machine_type_configs).map(([key, val]) => [
      key,
      camelCaseKeys(val),
    ]),
  );
  const availableStacks = Object.fromEntries(
    Object.entries(originalStacksAndMachines.available_stacks).map(([key, val]) => [key, camelCaseKeys(val)]),
  );

  return {
    availableStacks,
    availableMachineTypeConfigs,
  } as unknown as StackAndMachineConfiguration;
};

export default transformStacksAndMachineTypes;
